import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterStateService } from './router-state.service';

@NgModule({
  imports: [CommonModule],
  providers: [RouterStateService]
})
export class ShaRouterModule {}
